import axios from "axios";
import { createContext, useContext, useState } from "react";
import { UserContext } from "./UserContext.js";
import { toast } from "react-toastify";

export let OrderContext = createContext();

export default function OrderContextProvider(props) {
    const [talabatCount, setTalabatCount] = useState(0);
    const { userToken } = useContext(UserContext);

    const header = {
        token: `${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")
            }`,
    };

    async function getTalabatCount() {
        try {
            const { data } = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/api/v1/order/getLoggedUserOrder?limit=99&page=1`,
                { headers: header }
            );

            if (data.message === "success") {
                setTalabatCount(data.results || 60);
            }
        } catch (error) {
            toast.error(error.response?.data.message || "Failed to load order count");
        }
    }

    return (
        <OrderContext.Provider value={{ talabatCount, getTalabatCount }}>
            {props.children}
        </OrderContext.Provider>
    );
}
